import blue from '@material-ui/core/colors/blue';
import green from '@material-ui/core/colors/green';
import yellow from '@material-ui/core/colors/yellow';
import deepPurple from '@material-ui/core/colors/deepPurple';
import orange from '@material-ui/core/colors/orange';
import grey from '@material-ui/core/colors/grey';

const rowStyleCampagne = (record, index, defaultStyle = {}) => {

    if (record && record.status === 'ATTENTE' )
        return {
            ...defaultStyle,
            borderLeftColor: blue[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

    if (record && record.status === 'PROC' )
        return {
            ...defaultStyle,
            borderLeftColor: grey[600],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };


    if (record && record.status === 'FERMER' )
        return {
            ...defaultStyle,
            borderLeftColor: orange[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

    if (record && record.status==='ENROUTE')
    return {
        ...defaultStyle,
        borderLeftColor: yellow[500],
        borderLeftWidth: 4,
        borderLeftStyle: 'solid',
    };
  
        if (record && record.status === 'ARRIVE')
        return {
            ...defaultStyle,
            borderLeftColor: deepPurple[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

        if (record && record.status === 'FIN')
        return {
            ...defaultStyle,
            borderLeftColor: green[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };
 
    return defaultStyle;

};

export default rowStyleCampagne;